(function () {
  'use strict';

  // ============================================================
  // köbi — Eigener Reorder-Handler (Storefront-Seite)
  // ------------------------------------------------------------
  // Gegenstueck zur Customer-Account-UI-Extension `reorder-action` im
  // Inhouse-Tools-Plugin. Loest Shopifys nativen Buy-Again-Button ab, der
  // beim Nachbestellen ALLE Line-Item-Properties wegwirft (Design +
  // `_bottle_count` → Pfand verschwindet).
  //
  // Ablauf:
  //   1) Plugin-Mint-Endpoint 302-redirected den Kunden auf
  //        https://<shop>/cart?reorder=<orderId>&exp=<exp>&token=<token>
  //   2) Dieses Script liest die Params, holt via App-Proxy
  //        GET /apps/label/reorder?reorder=…&exp=…&token=…
  //      den Rebuild-Plan (Variant-IDs + vollstaendige Properties).
  //   3) Warenkorb wird geleert und Zeile fuer Zeile via /cart/add.js neu
  //      aufgebaut — inkl. aller Properties (identisches Etikett, Pflicht-
  //      angaben, _Editor-State). Die Pfand-Zeile wird NICHT mit-readded;
  //      koebi-cart-pfand.js ergaenzt sie automatisch aus `_bottle_count`.
  //   4) Redirect auf /cart (ohne Params) → Pfand-JS + Pflicht-Haekchen
  //      (Alter/Designfreigabe/Widerruf) greifen wie gewohnt.
  //
  // Hinweise (skipped/needsRedesign/Preis) werden in sessionStorage
  // gestasht und nach dem Redirect als Banner ueber dem Warenkorb gezeigt.
  // ============================================================

  var PROXY_URL = '/apps/label/reorder';
  var NOTICE_KEY = 'koebi_reorder_notice';

  var params = new URLSearchParams(window.location.search);
  var orderId = params.get('reorder');
  var exp = params.get('exp');
  var token = params.get('token');

  // ── Phase B: nach dem Rebuild auf /cart → Banner aus sessionStorage ──
  if (!orderId) {
    renderStashedNotice();
    return;
  }

  // ── Phase A: Rebuild ausfuehren ─────────────────────────────────────
  if (!exp || !token) {
    stashNotice({ error: 'Reorder-Link unvollständig.' });
    cleanRedirectToCart();
    return;
  }

  runReorder(orderId, exp, token);

  // ────────────────────────────────────────────────────────────────────
  async function runReorder(orderId, exp, token) {
    var overlay = showOverlay('Artikel werden in den Warenkorb gelegt …');
    try {
      var planResp = await fetch(
        PROXY_URL +
          '?reorder=' + encodeURIComponent(orderId) +
          '&exp=' + encodeURIComponent(exp) +
          '&token=' + encodeURIComponent(token),
        { headers: { Accept: 'application/json' } }
      );

      var plan = null;
      try { plan = await planResp.json(); } catch (e) {}

      if (!planResp.ok || !plan || !plan.ok) {
        var reason =
          plan && plan.error === 'expired'
            ? 'Der Reorder-Link ist abgelaufen. Bitte erneut auf „Erneut bestellen" klicken.'
            : 'Die Bestellung konnte nicht geladen werden. Bitte versuche es erneut.';
        stashNotice({ error: reason });
        cleanRedirectToCart();
        return;
      }

      // Warenkorb leeren — Reorder ersetzt den Inhalt durch die Bestellung.
      await fetch('/cart/clear.js', { method: 'POST' });

      // Zeile fuer Zeile adden (robust: ein Fehler kippt nicht den Rest).
      var added = 0;
      var failed = [];
      var items = Array.isArray(plan.items) ? plan.items : [];
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        try {
          var addResp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [
                {
                  id: it.id,
                  quantity: it.quantity,
                  properties: it.properties || {}
                }
              ]
            })
          });
          if (addResp.ok) {
            added += 1;
          } else {
            failed.push(titleFromProps(it));
          }
        } catch (e) {
          failed.push(titleFromProps(it));
        }
      }

      stashNotice({
        added: added,
        failed: failed,
        skipped: plan.skipped || [],
        needsRedesign: plan.needsRedesign || [],
        notes: plan.notes || []
      });

      // Pfand JETZT serverseitig ergaenzen und ABWARTEN, bevor wir auf /cart
      // redirecten. Sonst haengt das Pfand am asynchronen Post-Load-Sync von
      // koebi-cart-pfand.js und erscheint erst nach manuellem Reload.
      // Fallback (Script-Reihenfolge/alt): kurzer Wait — der /cart-Load
      // triggert den Sync ohnehin nochmal.
      if (typeof window.koebiPfandSync === 'function') {
        try { await window.koebiPfandSync(); } catch (e) {}
      } else {
        await wait(150);
      }
      cleanRedirectToCart();
    } catch (e) {
      console.warn('[koebi-reorder] Rebuild fehlgeschlagen:', e);
      stashNotice({ error: 'Beim Wiederherstellen ist ein Fehler aufgetreten.' });
      cleanRedirectToCart();
    } finally {
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }
  }

  function titleFromProps(it) {
    return (it && it.properties && it.properties._Sorte) || 'Artikel';
  }

  function cleanRedirectToCart() {
    window.location.replace('/cart');
  }

  function wait(ms) {
    return new Promise(function (r) { window.setTimeout(r, ms); });
  }

  // ── Overlay ─────────────────────────────────────────────────────────
  function showOverlay(text) {
    try {
      var el = document.createElement('div');
      el.setAttribute('role', 'status');
      el.style.cssText =
        'position:fixed;inset:0;z-index:99999;display:flex;align-items:center;' +
        'justify-content:center;background:rgba(255,255,255,0.92);' +
        'font:500 18px/1.4 inherit;color:#1F1F1F;text-align:center;padding:24px;';
      el.textContent = text;
      document.body.appendChild(el);
      return el;
    } catch (e) {
      return null;
    }
  }

  // ── Notice-Stash + Render ───────────────────────────────────────────
  function stashNotice(notice) {
    try {
      window.sessionStorage.setItem(NOTICE_KEY, JSON.stringify(notice));
    } catch (e) {}
  }

  function renderStashedNotice() {
    var raw;
    try {
      raw = window.sessionStorage.getItem(NOTICE_KEY);
      if (raw) window.sessionStorage.removeItem(NOTICE_KEY);
    } catch (e) {
      return;
    }
    if (!raw) return;

    var n;
    try { n = JSON.parse(raw); } catch (e) { return; }
    if (!n) return;

    // Nur auf der Warenkorb-Seite einblenden.
    if (window.location.pathname.replace(/\/+$/, '') !== '/cart') return;

    var msgs = [];
    if (n.error) msgs.push({ tone: 'error', text: n.error });

    if (Array.isArray(n.needsRedesign) && n.needsRedesign.length) {
      n.needsRedesign.forEach(function (r) {
        msgs.push({
          tone: 'warn',
          html:
            'Für „' + escapeHtml(r.title) + '" ist die Druckdatei nicht mehr ' +
            'verfügbar. <a href="' + encodeURI(r.editorUrl || '#') +
            '">Etikett neu gestalten</a>.'
        });
      });
    }

    if (Array.isArray(n.skipped) && n.skipped.length) {
      var skippedTitles = n.skipped.map(function (s) { return s.title; }).join(', ');
      msgs.push({
        tone: 'warn',
        text:
          'Nicht mehr bestellbar und übersprungen: ' + skippedTitles + '.'
      });
    }

    if (Array.isArray(n.notes) && n.notes.length) {
      var priceChanged = n.notes.filter(function (x) { return x.info === 'price_changed'; });
      if (priceChanged.length) {
        msgs.push({
          tone: 'info',
          text:
            'Bei einzelnen Artikeln hat sich der Preis seit deiner letzten ' +
            'Bestellung geändert.'
        });
      }
    }

    if (!msgs.length) return;
    injectBanner(msgs);
  }

  function injectBanner(msgs) {
    var host =
      document.getElementById('main-cart-items') ||
      document.querySelector('cart-items') ||
      document.querySelector('main') ||
      document.body;
    if (!host) return;

    var wrap = document.createElement('div');
    wrap.className = 'koebi-reorder-notice';
    wrap.style.cssText = 'margin:0 0 16px;display:grid;gap:8px;';

    msgs.forEach(function (m) {
      var bar = document.createElement('div');
      var bg =
        m.tone === 'error' ? '#FCE8E6' :
        m.tone === 'warn'  ? '#FEF6E0' : '#EEF2FF';
      bar.style.cssText =
        'padding:12px 14px;border-radius:8px;background:' + bg + ';' +
        'color:#1F1F1F;font:400 15px/1.45 inherit;';
      if (m.html) { bar.innerHTML = m.html; } else { bar.textContent = m.text; }
      wrap.appendChild(bar);
    });

    host.parentNode ? host.parentNode.insertBefore(wrap, host) : host.appendChild(wrap);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
})();
